/**
 * @description This is circuit breaker Util which will check if api gives response within specified time or else will raise a rollbar
 * @param fetchCall  apicall that needs to be done
 * @param interval timeout time
 * @returns Promise with response data if api call gets complete within specified time
 * */

import RollbarUtils from "./RollbarUtils";


export class CircuitBreakerUtils {
    static fetchDataSequentially = (fetchCall: any, interval: number, rollbarLogInfo?: any) => {
        const timeout = new Promise((resolve, reject) => {
            setTimeout(reject, interval * 1000);
        })

        const apiRequest = new Promise((resolve, reject) => { resolve(fetchCall) });

        return Promise.race([apiRequest, timeout]).catch(err => {
            RollbarUtils.sendErrorToRollbar(new Error("Fetch Care Recommendations exceeded the time limit"), rollbarLogInfo ? rollbarLogInfo : {});
        })
    }
}